import axios, {CancelTokenSource, CancelToken} from 'axios';

export default class AxiosCancelTokenHelper {
   private cancelTokenSource: CancelTokenSource;
   private isCancelledValue: boolean;

   get isCancelled(): boolean {
      return this.isCancelledValue;
   }

   constructor() {
      this.cancelTokenSource = axios.CancelToken.source();
      this.isCancelledValue = false;
   }

   getToken(): CancelToken {
      return this.cancelTokenSource.token;
   }

   cancel(): void {
      this.cancelTokenSource.cancel();
      this.isCancelledValue = true;
   }
}
